<template>
  <div class="w-50 bg-transparent text-center overflow-hidden h-header text-15 f-c flex-col">
    <transition name="layout-logo-fade">
      <router-link key="collapse" to="/">
        <img src="~/assets/logo.png" class="h-9 align-middle inline-block" />
      </router-link>
    </transition>
  </div>
</template>
